export default function SolutionsSection() {
  const solutions = [
    {
      title: 'ブランク復帰サポート',
      description: '担当者が付き添う職場見学や、毎月の面談を通じて、安心して復帰できる環境をご用意。登録スタッフの45%がブランク、他業種からの復帰です。',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/259fb6ec06f53d84e359b8085635e3bb.png',
      features: ['担当者と月1面談', '職場見学可能', '先輩スタッフのサポート']
    },
    {
      title: '柔軟な働き方',
      description: '週3日、Wワークも OK。曜日固定や時間固定もできるので、家事育児と両立、プライベート重視派のあなたの、ライフスタイルに合わせた働き方を提案します。',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/3276502f64bb783e335948e27b394669.png',
      features: ['週3日〜 OK', '短時間勤務可能', 'シフト調整柔軟']
    },
    {
      title: '地域最高時給保証',
      description: '業界特化だからこそ実現できる高時給。せっかく取った資格、苦労して身につけた経験とスキルを正当に評価します。',
      image: 'https://static.readdy.ai/image/f95cd9c4b1c2dbe7a0ca3fd438a74a8e/0e909a267994c357f8009d2816cb735b.png',
      features: ['地域最高時給', '昇給制度あり', '資格取得支援制度']
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
            トラストなら、すべて解決できます
          </h2>
          <p className="text-lg sm:text-xl text-gray-600">
            介護業界特化だからこそ実現できる3つの強み
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {solutions.map((solution, index) => (
            <div key={index} className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg">
              <div className="flex flex-col items-center gap-6 sm:gap-8">
                <img 
                  src={solution.image}
                  alt={solution.title}
                  className="w-28 h-28 sm:w-32 sm:h-32 object-cover"
                />
                <div className="text-center">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                    {solution.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6">
                    {solution.description}
                  </p>
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <div className="text-sm font-medium text-blue-800 space-y-1">
                      {solution.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center justify-center">
                          <span>✓ {feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <a 
            href="https://lin.ee/MJ3LVM2" 
            target="_blank"
            rel="noopener noreferrer"
            className="line-btn-primary inline-flex items-center space-x-3 text-base sm:text-lg font-medium whitespace-nowrap cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-line-fill text-xl"></i>
            </div>
            <span>まずは気軽に LINE で相談</span>
          </a>
        </div>
      </div>
    </section>
  );
}